import _get from 'lodash.get';
import { getAsString } from '../../utils/tracking';

$ {
        var currentState;
        var callToAction;
        var textSpans;
        var text;
        var tracking;
        var isFollow;
        var isFakeLink = data.fakeLink ? "fake-link" : "";

    if (state.data.onCallToAction) {
        currentState = state.data.initialState === "ON" ? true : false;
        var callToActionState = currentState ? "onCallToAction" : "offCallToAction";
        callToAction = _get(state, `data.${callToActionState}`);
        textSpans = callToAction.textSpans || [];
        text = _get(callToAction, 'text');
        tracking = getAsString([_get(callToAction, 'action.tracking')]);
        isFollow = currentState;
    } else {
        currentState = state.data.currentState;
        callToAction = _get(state, `data.stateToActionMap[${currentState}].callToAction`) || {};
        textSpans = callToAction.textSpans || [];
        tracking = getAsString(_get(callToAction, 'action.trackingList'));
        isFollow = currentState != 'FOLLOW' ? true : false;
    }
}

<ebay-button
    class=data.classes
    variant=isFakeLink
    priority='primary'
    size='large'
    disabled=state.disabled
    onClick('handleClick')
    aria-label=callToAction.accessibilityText
    data-foltrack=tracking
    aria-describedby=data.ariaDescribedby
    >
        <if(state.data.onCallToAction)>
            <follow-heart-icon isFollowing=isFollow waiting=state.disabled txtBusy='busy'/>
            <if (text && text !== "")>
                <div class="follow-ebay_text">${text}</div>
            </if>
        </if>
        <else>
            $ var last = textSpans.length - 1;
            <for|value, index| of=textSpans>
                <if(value.icon)>
                    <follow-heart-icon isFollowing=isFollow waiting=state.disabled txtBusy='busy'/>
                </if>
                <else>
                    <div class="follow-ebay_text">${value.text}<if(index !== last)> </if></div>
                </else>
            </for>
        </else>
</ebay-button>
